
<template>
   <van-popup v-model="dataTipShow" round position="bottom">
        <div class="tip-body">
        <div class="tip-content"> {{ tipContent }} </div>
        <div class="tip-button" @click="onButtonClick"> {{ buttonContent }} </div>
        </div>
    </van-popup>
  </template>
<script>

export default {
  name: 'TipPopupView',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    tipContent: {
      type: String,
      default: ''
    },
    buttonContent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dataTipShow: this.show
    }
  },
  watch: {
    show: function(newValue, oldValue) {
      this.dataTipShow = newValue
    },
    dataTipShow: function(newValue, oldValue) {
      this.$emit('change', newValue)
    }
  },
  methods: {
    onButtonClick() {
      this.$emit('onButtonClick')
      this.dataTipShow = false
    }
  }
}
</script>
  <style lang="scss" scoped>
  .tip-body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    padding: 36px 32px;
    .tip-content{
        font-size: 16px;
        font-weight: 400;
        color: #2C2C2C;
        word-wrap: break-word;
        margin-bottom: 40px;
    }
    .tip-button {
        background: linear-gradient(90deg, #5fd1db 0%, #28beca 100%);
        border: none;
        border-radius: 8px;
        font-weight: 500;
        height: 48px;
        line-height: 48px;
        width: 231px;
        font-size: 16px;
        color: white;
        text-align: center;
    }
  }
  </style>
